module.exports = __webpack_public_path__ + "img/jobmule_ricerca.2134e8b0.png";